import React from "react";
import { ACTION_ITEM_CATEGORY_DESCRIPTION_MAX_CHARS } from "../actionItemCategories";

/**
 * One compact, optional description input for the selected task label. The AI reads
 * it when picking a category ("Fundraising: anything about investors or the data room").
 * Controlled: the parent decides when to save (on blur / Enter).
 *
 * @example
 * <CategoryDescriptionInput
 *   label="Fundraising"
 *   value={draft}
 *   onChange={setDraft}
 *   onCommit={() => save(draft)}
 * />
 * // [ What belongs in “Fundraising”? (optional)            23/200 ]
 */
const CategoryDescriptionInput = ({
  label = "",
  value = "",
  onChange,
  onCommit,
  onEnter,
  disabled = false,
  autoFocus = false,
}) => {
  const max = ACTION_ITEM_CATEGORY_DESCRIPTION_MAX_CHARS;
  return (
    <div className="category-description-input">
      <div className="category-description-input__caption">
        <span className="category-description-input__title">
          {label ? <>Describe “{label}”</> : "Describe this label"}
        </span>
        <span className="category-description-input__help">
          Optional. The AI uses this to decide which tasks get this label.
        </span>
      </div>
      <div className="category-description-input__control">
      <input
        type="text"
        className="category-description-input__field"
        value={value}
        autoFocus={autoFocus}
        disabled={disabled}
        maxLength={max}
        placeholder="e.g. anything I owe a customer or prospect"
        aria-label={label ? `Description for ${label}` : "Description for the new label"}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={() => onCommit?.()}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            if (onEnter) onEnter();
            else e.currentTarget.blur();
          } else if (e.key === "Escape") {
            e.currentTarget.blur();
          }
        }}
      />
      {value.length >= max * 0.8 ? (
        <span className="category-description-input__count">
          {value.length}/{max}
        </span>
      ) : null}
      </div>
    </div>
  );
};

export default CategoryDescriptionInput;
